import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40ed9cf5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { style: {"width":"174px"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"space-between","color":"#C7C7CC"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "Lilith Wong"),
  /*#__PURE__*/_createElementVNode("span", null, "12-09")
], -1))
const _hoisted_5 = { class: "comment_item-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "comment_item"
      }, [
        _createElementVNode("img", {
          src: i.image
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(i.desc), 1)
        ])
      ]))
    }), 128))
  ]))
}